(function () {
  var SPEED_PX_PER_SEC = 40;
  var RESUME_DELAY_MS = 3000;

  document.addEventListener('DOMContentLoaded', function () {
    var list = document.querySelector('[id$="__multicolumn_AttnLN"] .multicolumn-list');
    if (!list) return;

    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var items = Array.prototype.slice.call(list.children);
    if (items.length === 0) return;

    function hasOverflow() {
      return list.scrollWidth > list.clientWidth + 1;
    }

    // Solo activamos el auto-scroll si la fila realmente se desborda
    // horizontalmente ANTES de clonar nada. Clonar primero (comportamiento
    // anterior) duplicaba permanentemente las tarjetas visibles cada vez
    // que el grid pasaba a varias filas en lugar de desbordarse.
    if (!hasOverflow()) {
      return;
    }

    var setWidth = 0;
    var rafId = null;
    var lastTime = null;
    var paused = true;
    var resumeTimer = null;

    function cloneSet() {
      items.forEach(function (item) {
        var clone = item.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        list.appendChild(clone);
      });
    }

    function measure() {
      if (!items.length) return;
      var first = items[0];
      var last = items[items.length - 1];
      setWidth = (last.offsetLeft + last.offsetWidth) - first.offsetLeft;
    }

    function step(time) {
      if (paused) {
        lastTime = null;
        rafId = requestAnimationFrame(step);
        return;
      }
      if (lastTime === null) lastTime = time;
      var delta = (time - lastTime) / 1000;
      lastTime = time;

      list.scrollLeft += SPEED_PX_PER_SEC * delta;
      if (setWidth > 0 && list.scrollLeft >= setWidth) {
        list.scrollLeft -= setWidth;
      }

      rafId = requestAnimationFrame(step);
    }

    function start() {
      list.style.setProperty('scroll-behavior', 'auto', 'important');
      list.style.setProperty('scroll-snap-type', 'none', 'important');
      if (rafId !== null) return;
      lastTime = null;
      rafId = requestAnimationFrame(step);
    }

    function stop() {
      list.style.removeProperty('scroll-behavior');
      if (rafId === null) return;
      cancelAnimationFrame(rafId);
      rafId = null;
      lastTime = null;
    }

    function pauseForInteraction() {
      paused = true;
      list.style.removeProperty('scroll-behavior');
      if (resumeTimer) clearTimeout(resumeTimer);
      resumeTimer = setTimeout(function () {
        paused = false;
        list.style.setProperty('scroll-behavior', 'auto', 'important');
      }, RESUME_DELAY_MS);
    }

    cloneSet();
    measure();
    window.addEventListener('resize', measure);

    list.addEventListener('touchstart', pauseForInteraction, { passive: true });
    list.addEventListener('pointerdown', pauseForInteraction);

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            paused = false;
            start();
          } else {
            paused = true;
            stop();
          }
        });
      },
      { threshold: 0.25 }
    );
    observer.observe(list);
  });
})();
